import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const styleDisableScrollbar = {
  className: 'base-ui-disable-scrollbar',
  element: /*#__PURE__*/_jsx("style", {
    href: "base-ui-disable-scrollbar",
    precedence: "base-ui:low",
    children: `.base-ui-disable-scrollbar{scrollbar-width:none}.base-ui-disable-scrollbar::-webkit-scrollbar{display:none}`
  })
};